import { Component, effect, inject, input, signal } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { TranslateStore, TranslateService, TranslateLoader, DEFAULT_LANGUAGE } from '@ngx-translate/core';

import { createSystemTranslateLoader, Question, SURVEY_DEFAULT_LANGUAGE_CODE, TranslationsService } from '@empathy/survey-core';

import { MainTabs } from '../../models/main-tabs.enum';
import { IEditorForm } from '../../models/survey-editor/editor-form.interface';
import { EditorTranslationsService } from '../../services/editor-translations.service';
import { SurveyEditorService } from '../../services/survey-editor.service';

@Component({
  selector: 'empathy-preview',
  templateUrl: './preview.component.html',
  styleUrls: ['./preview.component.scss'],
  providers: [
    TranslateStore,
    { provide: DEFAULT_LANGUAGE, useValue: null },
    TranslateService,
    {
      provide: TranslateLoader,
      useFactory: createSystemTranslateLoader,
      deps: [TranslationsService]
    }
  ]
})
export class PreviewComponent {
  welcomeScreenActive = input.required<boolean>();
  endPageScreenActive = input.required<boolean>();
  editorForm = input.required<FormGroup<IEditorForm>>();
  activeQuestion = input<Question>();

  translationsReady$ = signal(false);

  private translatationsService = inject(EditorTranslationsService);
  private surveyEditorService = inject(SurveyEditorService);
  private translate = inject(TranslateService);
  private defaultLanguageCode$ = inject(SURVEY_DEFAULT_LANGUAGE_CODE);

  constructor() {
    effect(
      () => {
        const defaultLanguageCode = this.defaultLanguageCode$();

        if (!defaultLanguageCode) {
          return;
        }

        this.translate.setDefaultLang(defaultLanguageCode);

        const activeLanguageCode = this.translatationsService.activeTranslationLanguage$()?.code;
        const previewUseDefaultLanguage = this.translatationsService.previewUseDefaultLanguage$();
        const mainTab = this.surveyEditorService.mainTab$();

        let langCode = defaultLanguageCode;

        if (mainTab == MainTabs.Translations && !previewUseDefaultLanguage && activeLanguageCode) {
          langCode = activeLanguageCode;
        }

        this.translationsReady$.set(false);
        this.translate.use(langCode).subscribe(() => this.translationsReady$.set(true));
      },
      { allowSignalWrites: true }
    );
  }
}
